// extracted by mini-css-extract-plugin
export default {"valueContainer":"ValueDisplay_valueContainer__BRduG","valueText":"ValueDisplay_valueText__h7MG8","checkbox":"ValueDisplay_checkbox__lVlrs"};